import React from 'react';
import cn from 'bem-cn';

import { Stack } from '../Stack/Stack';
import { ImageWithFadeIn } from '../ImageWithFadeIn';
import { sanitize } from '../../../utils/sanitize';

import { BannerProps } from './Banner.types';
import './Banner.scss';

const b = cn('simple-banner');

export const Banner: React.FC<BannerProps> = ({ text, image, onClick }) => {
    return (
        <Stack
            className={b({ clickable: Boolean(onClick) })}
            spacing={8}
            direction="row"
            alignItems="center"
            onClick={onClick}
        >
            <span className={b('text')} dangerouslySetInnerHTML={{ __html: sanitize(text) }} />
            {image && <ImageWithFadeIn src={image} alt="" className={b('image')} />}
        </Stack>
    );
};
